import { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';
import { ErrorState } from '@/components/ErrorState';
import { isChunkLoadError, reloadOnceForStaleChunk } from '@/lib/chunk-reload';
import { trackException } from '@/lib/telemetry';

/** Root errorElement: auto-recovers stale-deploy chunk errors, softens everything else. */
export function RouteErrorBoundary() {
  const error = useRouteError();
  const chunkError = isChunkLoadError(error);

  useEffect(() => {
    if (chunkError) reloadOnceForStaleChunk();
    // Render-crash errors caught by the router never hit window.onerror, so
    // exception autocapture misses them without this. Stale-chunk reloads are
    // expected deploy noise, not defects.
    else trackException(error, { surface: 'route_error_boundary' });
  }, [chunkError, error]);

  if (chunkError) {
    return (
      <div className="flex min-h-svh items-center justify-center px-6">
        <ErrorState
          title="Nova versão disponível"
          message="O aplicativo foi atualizado — recarregando para carregar a versão mais recente."
          actionLabel="Recarregar agora"
          onAction={() => window.location.reload()}
        />
      </div>
    );
  }

  const message = error instanceof Error ? error.message : 'Erro inesperado.';
  return (
    <div className="flex min-h-svh items-center justify-center px-6">
      <ErrorState
        title="Algo deu errado"
        message={message}
        actionLabel="Recarregar"
        onAction={() => window.location.reload()}
      />
    </div>
  );
}
